
import { createRouter, createWebHistory } from 'vue-router';

const routes = [
  {
    path: '/',
    redirect: '/login',
  },
  {
      path: '/login',
      component: () => import('@/views/Login.vue'),
      meta: { hideInMenu: true }
  },
  {    path: '/home',
    component: () => import('@/views/Home.vue'),
    children:[      {
        path: '/bom/list',
        name: 'BomList',
        component: () => import('@/views/bom/List.vue')
      },
      {
        path: '/bom/add',
        name: 'BomAdd',
        component: () => import('@/views/bom/BomAddEdit.vue')
      },
      {
        path: '/bom/edit/:id',
        name: 'BomEdit',
        component: () => import('@/views/bom/BomAddEdit.vue')
      },
      {
        path: '/taocan/list',
        name: 'ComboCfg',
        component: () => import('@/views/taocan/List.vue')
      },
      {
        path: '/merchant/list',
        name: 'MerchantList',
        component: () => import('@/views/merchant/List.vue')
      },
      {
        path: '/warehouseMerchant/list',
        name: 'WarehouseMerchantList',
        component: () => import('@/views/warehouseMerchant/List.vue')
      }
    ]
  },{
    path: '/password',
    component: () => import('@/views/Password.vue')
  }
];

const router = createRouter({
  history: createWebHistory(),
  routes,
});



export default router;
